// Clinic map

import addGoogleMapClinic from '../../scripts/app/google-map-clinic';

addGoogleMapClinic('.jsClinicMap');
